const production = {
    env: 'production',
    supportedLanguages: ['en'],
    carePortal: {
        urls: {
            adminAuthUrl: 'https://attus.m1amdocs.com/',
        },
        agentClientId: 'HaloCTestRP',
        ssoClientId: 'haloeFederationClientID',
        ssoClientSecret: '',
        OAuthParam: {
            scope: 'openid profile',
            extras: {},
        },
        redirectOnSessionExpire: false,
    },
    urls: {
        apiUrl: 'https://attus.m1amdocs.com/platform/rest/v85',
        authUrl: 'https://attus.m1amdocs.com',
        userPreferencesUrl: 'https://attus.m1amdocs.com/customData',
        storefrontUrl: 'https://attus.m1amdocs.com/storefront',
        emi: {
            baseUrl: 'https://waf-attus-emi-wa-p001.ifs.vubiquity.com/curation-api',
            homePath: '3.0/{population}/1',
            defaultPopulation: 'prod',
        },
        proxyUrl: 'https://waf-attus-metadata-api-p001.ifs.vubiquity.com/maculosa/v3.1',
        ifsApiUrl: 'https://plm.m1amdocs.com/el',
        iframePaymentUrl: 'https://www.att.com/acctmgmt/paymentmgmt/paymentmethods',
    },
    origins: {
        preconnect: true, // boolean: false if you want to disable preconnect
        // array of strings: list of endpoints to preconnect to
        endpoints: [
            'https://m1amdocs.io',
            'https://attus.m1amdocs.com',
            'https://waf-attus-emi-wa-p001.ifs.vubiquity.com',
            'https://waf-attus-metadata-api-p001.ifs.vubiquity.com',
        ],
    },
    clientId: 'm23726',
    OAuthParam: {
        scope: 'openid profile storefront customData',
        grantType: 'authorization_code',
        requestMode: 'form_post',
        endpoint: {
            auth: '/oidc/authorize',
            token: '/oidc/token',
            refreshToken: '/oauth/token',
        },
        extras: {
            response_mode: 'form_post',
        },
        debugMode: true,
        forcePollingIntervalSecs: 10,
    },
    proxyVersion: 3,
    encryption: {
        enabled: true,
        passphrase: 'mY5}vH9%pN0!dW7{xI7$aG8{iK8}aT2/',
    },
    marketone: {
        skipRefreshToken: true,
        enableUserPreferencesApi: true,
        apiVersion: 'V2',
        retrieveOnlyActiveSubscriptions: false,
    },
    firebaseConfig: {
        enabled: false,
        apiKey: '',
        authDomain: '',
        projectId: '',
        storageBucket: '',
        messagingSenderId: '',
        appId: '',
        measurementId: '',
    },
}

export default production
